import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import SelectVehicle from './Vehicle'

const fetchAutoYears = async () =>
  await axios
    .get('https://rwzqgyxmfd.execute-api.us-east-1.amazonaws.com/prod/v1/years')
    .then((res) => res.data)

function AutoYears(props) {
  const { isLoading, isError, error, data } = useQuery(['autoYears'], () =>
    fetchAutoYears(),
  )

  if (isLoading) return 'Loading...'

  if (isError) return 'An error has occurred: ' + JSON.stringify(error)

  const options = data.data
    .map(({ year }) => ({ placeholder: year, value: year }))
    .slice()
    .reverse()

  return (
    <div>
      <SelectVehicle {...props} options={options} />
    </div>
  )
}

export default AutoYears
